<template>
	<div>
		<!-- Menu  Mobile-->

		<v-app-bar  class="bar_nav black"   scroll-target="#scrolling-techniques-7" dark
			prominent dense v-if="$vuetify.breakpoint.smAndDown">
			<v-app-bar-nav-icon cols="3" @click.stop="drawer = !drawer" x-large class="my-auto mx-0 d-flex flex-shrink-0"
				aria-label="Abrir menú de navegación">
			</v-app-bar-nav-icon>

			<v-col cols="1" style="min-width: 100px; max-width: 100%" class="flex-grow-1 flex-shrink-0">
				<router-link :to="{ path: '/' }" title="TicketShop" tag="a">
					<v-img class="mx-auto mt-2" max-height="96" max-width="72" src="/images/logo-dark.svg" alt=""></v-img>
				</router-link>
			</v-col>

			<!-- Avatar -->
			<v-col class="my-auto flex-grow-0 flex-shrink-1">
				<!-- Login -->
				<router-link width="52" height="52" :to="{ path: '/login' }"
					aria-label="Ir a la página de inicio de sesión">
					<v-btn v-if="!$store.state.user.accessToken" icon x-large v-on="on" class="d-flex d-md-none order-3"
						aria-label="Iniciar sesión">
						<v-avatar class="profile" color="primaryContainer">

							<v-img src="/images/avatar.svg" alt="Avatar de usuario"> </v-img>

						</v-avatar>
					</v-btn>
				</router-link>

				<!-- Usuario Logeado -->
				<v-menu transition="slide-y-transition" bottom left min-width="200px" rounded offset-y
					v-if="$store.state.user.accessToken">
					<template v-slot:activator="{ on }">
						<v-btn icon x-large v-on="on">
							<v-avatar class="profile" color="primaryContainer" size="48">
								<span class="primary--text text-h5">
									{{ usuario.nombre.substr(0, 1) }}
								</span>
							</v-avatar>
						</v-btn>
					</template>

					<!-- Menu Usuario -->
					<v-card>
						<v-list-item-content class="justify-center">
							<div class="mx-auto text-center">
								<span class="onSurface--text text-h4">
									{{ usuario.nombre }}
								</span>
								<p class="text-caption mt-1">
									{{ usuario.email }}
								</p>
								<v-divider class="my-2"></v-divider>
								<router-link :to="{
									name: 'perfil',
								}">
									<v-btn class="black--text" text rounded>Mi perfil
									</v-btn>
									<v-divider class="my-2"></v-divider>
								</router-link>
								
								
									<v-divider class="my-2"></v-divider>
								
								<router-link :to="{
									name: 'perfil',
									params: {
										optPerfil: 3,
									},
								}" v-if="usuario.id_rol == 2">
									<v-btn depressed rounded text>
										Mis Compras
									</v-btn>
									<v-divider class="my-2"></v-divider>
								</router-link>

								<router-link :to="{
									name: 'contacto',
								}">
									<v-btn depressed rounded text>
										Soporte
									</v-btn>
									<v-divider class="my-2"></v-divider>
								</router-link>
								<!-- Acceso SuperUsuario -->
								<router-link :to="{
									name: 'misEventos',
								}" v-if="
									usuario.id_rol == 1 ||
									usuario.id_rol == 4 ||
									usuario.id_rol == 7 ||
									usuario.id_rol == 5
								">
									<v-btn depressed rounded text>
										Mis Eventos
									</v-btn>
									<v-divider class="my-2"></v-divider>
								</router-link>
								<router-link :to="{
									name: 'PuntosVentaJefePunto',
								}" v-if="usuario.id_rol == 7"><v-btn depressed rounded text>Puntos de Venta</v-btn>
								</router-link>
								<router-link :to="{
									name: 'pagosParciales',
								}" v-if="usuario.id_rol == 5">
									<v-btn depressed rounded text>
										Pagos parciales
									</v-btn>
								</router-link>
								<router-link :to="{
									name: 'eventosAprobacion',
								}" v-if="usuario.id_rol == 6">
									<v-btn depressed rounded text>
										<v-divider class="my-2"></v-divider>
										Eventos aprobacion
									</v-btn>
								</router-link>

								<v-btn @click.prevent="logout" rounded text>
									<v-divider class="my-2"></v-divider>

									Cerrar sesion
								</v-btn>
							</div>
						</v-list-item-content>
					</v-card>
				</v-menu>
			</v-col>
		</v-app-bar>

		<v-navigation-drawer floating app temporary v-model="drawer" width="100vh">
			<v-app-bar class="white pa-4 mx-2" flat prominent dense v-if="$vuetify.breakpoint.smAndDown">
				<v-app-bar-nav-icon>

					<router-link :to="{ path: '/' }" title="TicketShop" tag="a">
						<v-img class="" src="/images/logo-black.svg" alt=""></v-img>
					</router-link>
				</v-app-bar-nav-icon>
				<v-spacer></v-spacer>

				<v-btn icon>
					<v-icon @click.stop="drawer = !drawer" x-large>mdi-close</v-icon>
				</v-btn>

			</v-app-bar>
			<v-divider class="mt-0 pt-0"></v-divider>

			<v-list rounded>
				<router-link :to="{ path: '/' }">
					<v-row class="onSurface--text font-weight-medium text-h5 ml-6 mb-4">
						Inicio
					</v-row>

				</router-link>


				<v-list-group v-for="(item, index) in items" :key="item.title" v-show="index < items.length - 1">
					<template v-slot:activator>
						<v-list-item two-line class="px-2 font-weight-medium text-h5">{{
							item.title }}
						</v-list-item>

					</template>

					<v-list-item block class="surfaceContainerLowest onSurface--text" :to="category.path"
						v-for="category in item.categorys" :key="category.title">
						<v-list-item-content>
							<v-list-item two-line block link @click="filterEventos(1, category.title)"
								class="pl-16 font-weight-medium text-h5">
								<v-icon color="primary" large class="mr-2">
									{{ category.icon }}
								</v-icon>
								{{ category.title }}
							</v-list-item>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>

				<router-link :to="{ path: '/puntosVenta' }">
					<v-row class="onSurface--text font-weight-medium text-h5 ml-6 mt-4 ">
						Puntos de Venta
					</v-row>
				</router-link>
				<v-row class="mt-8">
					<a href="/pqr"
						title="Peticiones, Quejas y Reclamos">
						<v-text class="onSurface--text font-weight-medium text-h5 ml-6 ">
						Ayuda
					</v-text>
					</a>
				</v-row>
				
			</v-list>
		</v-navigation-drawer>




		<!-- Nav Escritorio -->
		<v-toolbar v-if="$vuetify.breakpoint.mdAndUp" overflow-y-visible class="black" hide-on-scroll
			scroll-target="#scrolling-techniques-4">
			<v-container class="d-flex align-content-center">
				<!-- Logotipo Ticket Shop -->
				<router-link :to="{ path: '/' }" class="logo-new my-auto" title="TicketShop" tag="a">
					<v-img src="/images/logo-dark.svg" max-width="48"> </v-img>
				</router-link>
				<v-spacer></v-spacer>

				<!-- Menu  desktop-->

				<v-container class="py-0 d-flex align-center flex-sm-nowrap pr-0" height="100"
					v-if="$vuetify.breakpoint.mdAndUp">
					<v-menu ms-5 transition="slide-y-transition" open-on-hover close-on-content-click offset-y
						v-for="item in items" :key="item.title">
						<template v-slot:activator="{ on, attrs }">
							<v-btn v-if="item.categorys.length" text text-capitalize
								class="text-body-2 onPrimary--text font-weight-bold" v-on="on" v-bind="attrs">
								{{ item.title }}
								<v-icon class="ml-2">
									{{ item.icon }}
								</v-icon>
							</v-btn>

							<router-link v-else :to="item.path">
								<v-btn text text-capitalize class="text-body-2 onPrimary--text font-weight-bold" v-on="on"
									v-bind="attrs">
									{{ item.title }}
									<v-icon class="ml-2">
										{{ item.icon }}
									</v-icon>
								</v-btn>
							</router-link>
						</template>

						<v-list-item v-if="item.categorys.length" width="120"
							class="surfaceContainerLowest onSurface--text py-3 px-5" :to="category.path"
							v-for="category in item.categorys" :key="category.title"> <v-list-item-content> <v-list-item-title
									tag="a" class="onSurface--text" @click="filterEventos(1, category.title)">
									<v-icon color="primary" class="mr-2">
										{{ category.icon }}
									</v-icon>
									{{ category.title }}
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>


					</v-menu>


					<v-spacer></v-spacer>
					
					<nav v-if="!$store.state.user.accessToken" max-width="260">
						
							
					
						<router-link :to="{ path: '/login' }">
							<v-btn class="pa-4" text-color="donPrimary" color="dPrimary" 
								rounded><v-icon  class="mr-2">mdi-account</v-icon>Iniciar sesión</v-btn>
						</router-link>
					</nav>
				</v-container>



				<!-- Avatar -->
				<v-row justify-items="center">
					<!-- Login -->
					<v-btn icon x-large v-on="on" class="d-flex d-sm-none order-3">
						<v-avatar class="profile" color="primaryContainer" size="48" v-if="!$store.state.user.accessToken">
							<router-link :to="{ path: '/login' }">
								<v-img src="/images/avatar.svg"> </v-img>
							</router-link>
						</v-avatar>
					</v-btn>

					<!-- Usuario Logeado -->
					<v-menu transition="slide-y-transition" bottom left min-width="200px" rounded offset-y
						v-if="$store.state.user.accessToken">
						<template v-slot:activator="{ on }">
							<v-btn icon x-large v-on="on">
								<v-avatar class="profile" color="primaryContainer" size="48">
									<span class="primary--text text-h5">
										{{ usuario.nombre.substr(0, 1) }}
									</span>
								</v-avatar>
							</v-btn>
						</template>

						<!-- Menu Usuario -->
						<v-card>
							<v-list-item-content class="justify-center">
								<div class="mx-auto text-center">
									<span class="onSurface--text text-h4">
										{{ usuario.nombre }}
									</span>
									<p class="text-caption mt-1">
										{{ usuario.email }}
									</p>
									<v-divider class="my-2"></v-divider>
									<router-link :to="{
										name: 'perfil',
									}">
										<v-btn class="black--text" text rounded>Mi perfil
										</v-btn>
										<v-divider class="my-2"></v-divider>
									</router-link>
									
										<a href="/pqr"
											title="Peticiones, Quejas y Reclamos">
											<v-btn depressed rounded text>
											Ayuda
										</v-btn>
										</a>
										<v-divider class="my-2"></v-divider>
									
									<router-link :to="{
										name: 'perfil',
										params: {
											optPerfil: 3,
										},
									}" v-if="usuario.id_rol == 2">
										<v-btn depressed rounded text>
											Mis Compras
										</v-btn>
										<v-divider class="my-2"></v-divider>
									</router-link>

									<router-link :to="{
										name: 'contacto',
									}">
										<v-btn depressed rounded text>
											Soporte
										</v-btn>
										<v-divider class="my-2"></v-divider>
									</router-link>
									<!-- Acceso SuperUsuario -->
									<router-link :to="{
										name: 'misEventos',
									}" v-if="
										usuario.id_rol == 1 ||
										usuario.id_rol == 4 ||
										usuario.id_rol == 7 ||
										usuario.id_rol == 5
									">
										<v-btn depressed rounded text>
											Mis Eventos
										</v-btn>
										<v-divider class="my-2"></v-divider>
									</router-link>
									<router-link :to="{
										name: 'PuntosVentaJefePunto',
									}" v-if="usuario.id_rol == 7"><v-btn depressed rounded text>Puntos de Venta</v-btn>
									</router-link>
									<router-link :to="{
										name: 'pagosParciales',
									}" v-if="usuario.id_rol == 5">
										<v-btn depressed rounded text>
											Pagos parciales
										</v-btn>
									</router-link>
									<router-link :to="{
										name: 'eventosAprobacion',
									}" v-if="usuario.id_rol == 6">
										<v-btn depressed rounded text>
											<v-divider class="my-2"></v-divider>
											Eventos aprobacion
										</v-btn>
									</router-link>

									<v-btn @click.prevent="logout" rounded text>
										<v-divider class="my-2"></v-divider>

										Cerrar sesion
									</v-btn>
								</div>
							</v-list-item-content>
						</v-card>
					</v-menu>
				</v-row>
			</v-container>
		</v-toolbar>
	</div>
</template>
<script>
export default {
	data() {
		return {
			drawer: false,
			group: null,
			currentRoute: window.location.pathname,
			ruta: null,
			watch: {
				group() {
					this.drawer = false;
				},
			},

			items: [

				{
					icon: "mdi-menu-down",
					categorys: [
						{
							title: "Conciertos",
							icon: "mdi-stadium",
						},
						{
							title: "Festivales",
							icon: "festival",
						},
					],
					title: "Conciertos",
				},
				{
					icon: "mdi-menu-down",
					categorys: [
						{
							title: "Conferencias",
							icon: "mdi-crowd",
						},
						{
							title: "Comedia",
							icon: "mdi-drama-masks",
						},
					],
					title: "Teatro",
				},
				{
					icon: "mdi-menu-down",
					categorys: [
						{
							title: "Fútbol",
							icon: "sports_soccer",
						},
						{
							title: "Baloncesto",
							icon: "sports_basketball",
						},
						{
							title: "Maratón",
							icon: "mdi-run",
						},
					],
					title: "Deportes",
				},
				{
					icon: "mdi-map-marker",
					categorys: [],
					title: "Puntos de Venta",
					path: "/puntosVenta"

				}
			],
			formData: {
				page: null,
				tiposEvento: null,
				fecha_inicio: null,
				fecha_fin: null,
				ciudadeseventos: null,
				filtro: null,
				vista: null,
				opcion: null,
				subcategoria: null
			},
			variableruta: window.location.pathname,
		};
	},

	watch: {
		$route(to, from) {
			this.currentRoute = window.location.pathname;
			this.ruta = this.currentRoute.split("/")
			this.ruta = this.ruta[1] + "/" + this.ruta[2]
		},
	},
	mounted() {
		this.$router.afterEach(() => {
			if (this.$vuetify.display.mobile) {
				this.drawer = false;
			}
		});
	},
	methods: {
		logout() {
			this.$store.dispatch("logout");
		},
		showModalLogin() {
			this.$store.commit("showModalLogin", true);
		},
		filterEventos(filtro = 0, category) {

			switch (category) {
				case "Conciertos":
					this.formData.tiposEvento = [1];
					this.formData.subcategoria = 'Conciertos';
					this.formData.opcion = "CONCIERTOS";
					break;
				case "Festivales":
					this.formData.tiposEvento = [11];
					this.formData.subcategoria = 'Festivales';
					this.formData.opcion = "FESTIVALES";
					break;
				case "Conferencias":
					this.formData.tiposEvento = [6];
					this.formData.subcategoria = 'Conferencias';
					this.formData.opcion = "CONFERENCIAS";
					break;
				case "Comedia":
					this.formData.tiposEvento = [12];
					this.formData.subcategoria = 'Comedia';
					this.formData.opcion = "COMEDIA";
					break;
				case "Fútbol":
					this.formData.tiposEvento = [9];
					this.formData.subcategoria = 'Fútbol';
					this.formData.opcion = "FÚTBOL";
					break;
				case "Baloncesto":
					this.formData.tiposEvento = [10];
					this.formData.subcategoria = 'Baloncesto';
					this.formData.opcion = "BALONCESTO";
					break;
				case "Maratón":
					this.formData.tiposEvento = [8];
					this.formData.subcategoria = 'Maratón';
					this.formData.opcion = "MARATÓN";
					break;
				default:
					this.formData.tiposEvento = [7];
					this.formData.subcategoria = 'Exhibición';
					this.formData.opcion = "EXHIBICIÓN";
					break;
			}

			this.formData.filtro = filtro;

			localStorage.setItem(
				"searchQuery",
				JSON.stringify(this.formData)
			);
			if (this.currentRoute != "/resultado") {
				this.$router.push({
					name: "resultado-filtro",
				});
			} else {
				this.$store.dispatch("evento/filterEventos", {
					page: this.formData.page,
					tiposEvento: this.formData.tiposEvento,
					fecha_inicio: this.formData.fecha_inicio,
					fecha_fin: this.formData.fecha_fin,
					ciudadeseventos: this.formData.ciudadeseventos,
					filtro: this.formData.filtro,
					opcion: this.formData.opcion,
				});
			}
		},
	},
	computed: {
		usuario() {
			return this.$store.getters["user/dataUserLogged"];
		},
		modalLogin() {
			return this.$store.getters["modalLogin"];
		},
	},
};
</script>
<style scoped>
a:hover {
	color: #715D00 !important;
	filter: brightness(1.1);
}

.ayuda:hover {
	color: #ffffff !important;
	filter: brightness(1.1);
	
}

svg:hover {
	filter: brightness(1.75);
}
</style>